import React, { Component } from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors } from '@myxplor/forms'
import './display-asset.css'

const pending = ({ loading, error }) => (
  <div className="displayAsset--pendingWrapper">
    {loading ? <Loading /> : <FormDisplayErrors errors={[error]} />}
  </div>
)

const display = ({ data, navHeight }) => (
  <embed
    type="application/pdf"
    src={`data:application/pdf;base64,${data}`}
    style={{
      marginTop: navHeight,
      width: '100vw',
      height: `calc(100vh - ${navHeight})`,
    }}
  />
)

const getNavHeight = doc => {
  const topNav = doc.querySelector('.topNav')

  // We always want to return a value in px, as we do a calc on the height when we display the embed
  return topNav ? topNav.getBoundingClientRect().height + 'px' : '0px'
}

class DisplayAssetView extends Component {
  componentDidMount() {
    // this is so we can make room for the top nav
    // (and the embed controls are visible to users)
    this.navHeight = getNavHeight(this.el.ownerDocument)
  }

  render() {
    const { loading, error, data } = this.props

    return (
      <div ref={el => (this.el = el)}>
        {loading || error
          ? pending({ loading, error })
          : display({ data, navHeight: this.navHeight })}
      </div>
    )
  }
}

export default DisplayAssetView



// WEBPACK FOOTER //
// ./src/ui/gov-messages/display-asset/views/index.jsx